"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1: function() {
        return _index.Body1;
    },
    body1ClassNames: function() {
        return _index.body1ClassNames;
    }
});
const _index = require("./components/presets/Body1/index");
